export default {
    reviewOrder: {
        reviewOrder: "Przegląd zamówienia"
    }
}